var map = {
	"./About.vue": "f820",
	"./Carrier.vue": "272b",
	"./Contact.vue": "b8fa",
	"./Documents.vue": "fb2d",
	"./Home.vue": "bb51",
	"./OnePage.vue": "a2c1",
	"./PrivacyPolicy.vue": "729e",
	"./Profile.vue": "c66d",
	"./Project.vue": "07bd",
	"./Prospectus.vue": "e8eb",
	"./SecurityPolicy.vue": "4aa5",
	"./Services.vue": "f23e",
	"./WhistleBlowing.vue": "394b"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | routes */ "routes").then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "9601";
module.exports = webpackAsyncContext;